import React from 'react';
import { styled, Grid } from '@mui/material';
import { FocusTheme } from '@/components/Focus/configs/theme';

interface Props {
  seasonOrder: number;
  episodeOrder: number;
}

const FocusTitleHierarchyBadge: React.FC<Props> = ({ seasonOrder, episodeOrder }) => {
  return (
    <TitleHierarchy container alignItems="stretch" sx={{ width: 'fit-content' }}>
      <TitleHierarchyParent item>Season {seasonOrder}</TitleHierarchyParent>
      <TitleHierarchyItem item xs>
        Episode {episodeOrder}
      </TitleHierarchyItem>
    </TitleHierarchy>
  );
};

export default FocusTitleHierarchyBadge;

const TitleHierarchy = styled(Grid)`
  min-height: 30px;
  border: 1px solid ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.highlight};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

const TitleHierarchyItem = styled(Grid)`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(0.25, 1)};
  color: ${({ theme }) => (theme.palette.mode === 'dark' ? (theme as FocusTheme).customOverrides.Calendar.highlight : theme.palette.text.primary)};
`;

const TitleHierarchyParent = styled(TitleHierarchyItem)`
  background-color: ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.highlight};
  color: ${({ theme }) => (theme as FocusTheme).customOverrides.Calendar.backgroundAlt};
`;
